import { ColorRecipeModel } from '../../models/color-recipe.model';
import { EngineColorRecipeModel } from '../../models/engine-color-recipe.model';
import { PaintBrushMode } from '../../models/paint-brush-mode.enum';

export class EditPaintStateModel {
  currentRecipe: ColorRecipeModel;
  brushMode: PaintBrushMode;
  storyRecipes: { [key: string]: EngineColorRecipeModel[] };
  recentRecipes: EngineColorRecipeModel[];
  uniqueStoryRecipes: EngineColorRecipeModel[];
}
